import React from 'react'
import { constants } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'


const CartSectionHeadline = ({ titleMessage, subTitleMessage, withShipping }) => (
  <Box mb="24">
    <Text
      semibold
      uppercase
      message={titleMessage}
      dataTestId={constants.testIds.payment.cartSection.title}
    />
    {
      withShipping && (
        <Box mt="4">
          <Text
            semibold
            size="14-24"
            message={subTitleMessage}
            dataTestId={constants.testIds.payment.cartSection.subtitle}
          />
        </Box>
      )
    }
  </Box>
)


export default CartSectionHeadline
